import React from "react";
import IconEdit from "../../../layout/others/icon_edit.svg";
import "../DOCOnline.scss";
import ConsentModal from "../ConsentModal";
import { useDOCOnlineContext } from "../DOCOnlineContext";
import { useTranslation } from "react-i18next";

const DOCOnlineWelcomePage = () => {
  const {
    setCurrentStep,
    docOnline,
    setShowConsentModal
  } = useDOCOnlineContext();

  const { t } = useTranslation();

  function checkIfCanCreateProfile() {
    if (!docOnline.isAcceptedConsent) {
      setShowConsentModal(true);
    } else {
      setCurrentStep(2);
    }
  }

  return (
    <>
      <h3 className="title-style">{t("Welcome")}</h3>
      <div className="mt-2 mb-2 subtitle-style" dangerouslySetInnerHTML={{ __html: docOnline.welcomeMessage }}></div>
      <div
        className="welcome-doc-button welcome-footer-doconline"
        onClick={() => {
          checkIfCanCreateProfile();
        }}
        title={t("Create my profile")}
        data-bs-toggle="tooltip"
        type="button"
      >
        <img src={IconEdit} alt="ico-ppl" width="50px" height="50px" />
        <p>{t("Create my profile")}</p>
      </div>
      <ConsentModal />
    </>
  );
};

export default DOCOnlineWelcomePage;
